<template>
    <div class="policy">
        <policy-header>{{title}}</policy-header>
        <div class="container">
            <section class="public">
                <ul class="doingList" v-if="!$route.query.mode && !$route.query.val">
                    <router-link 
                        tag="li"
                        class="lis"
                        v-for="item in policyList" 
                        :key="item.id"
                        :to="{name: 'Detail',query:{id:item.id,mode: 'ARTICLE'}}"
                    >
                        <div class="iconBox">
                            <img :src="item.image" alt="">
                        </div>
                        <div class="rt">
                            <p class="doingTitle">
                                {{ item.title }}
                            </p>
                            <p class="times">{{ item.updateDate.split(' ')[0] }}</p>
                        </div>
                    </router-link>
                </ul>
                <!-- 搜索展示 -->
                <ul class="doingList" v-if="$route.query.val">
                    <router-link 
                        tag="li"
                        class="lis"
                        v-for="item in policyList" 
                        :key="item.id"
                        :to="{name: 'Detail',query:{id:item.id,mode: 'PICTURE'}}"
                    >
                        <div class="iconBox">
                            <img :src="item.image" alt="">
                        </div>
                        <div class="rt">
                            <p class="doingTitle">
                                {{ item.name }}
                            </p>
                            <p class="times">{{ item.updateDate.split(' ')[0] }}</p>
                        </div>
                    </router-link>
                </ul>


                <ul class="doingList" v-if="$route.query.mode == 'PICTURE' || $route.query.mode == 'ARTICLE'">
                    <router-link 
                        tag="li"
                        class="lis"
                        v-for="item in policyList" 
                        :key="item.id"
                        :to="{name: 'Detail',query:{id:item.id,mode: $route.query.mode}}"
                    >
                        <div class="iconBox">
                            <img :src="item.image" alt="">
                        </div>
                        <div class="rt">
                            <p class="doingTitle">
                                {{ item.name }}
                            </p>
                            <p class="times">{{ item.updateDate.split(' ')[0] }}</p>
                        </div>
                    </router-link>
                </ul>
                <ul class="doingList" v-if="$route.query.mode == 'VIDEO'">
                    <li
                        class="lis"
                        v-for="item in policyList" 
                        :key="item.id"
                        @click="handleItemClick(item)"
                    >
                        <div class="iconBox">
                            <img :src="item.image" alt="">
                        </div>
                        <div class="rt">
                            <p class="doingTitle">
                                {{ item.name }}
                            </p>
                            <p class="times">{{ item.updateDate.split(' ')[0] }}</p>
                        </div>
                    </li>
                </ul>
            </section>
        </div>
    </div>
</template>

<script>
import policyHeader from '../../components/Header';
import BScroll from 'better-scroll'
export default {
    name: 'mall',
    components: {
        policyHeader
    },
    data() {
        return {
            policyList: [],
            title: '扶持政策',
            page: 1
        }
    },
    mounted() {
        if(this.$route.query.title && this.$route.query.id){
            let {id} = this.$route.query
            this.title = this.$route.query.title
            // this.getCompanyList(id)
            if(this.$route.query.mode){
                let {mode} = this.$route.query
                this.getPolicyList(id, mode)
            }else{
                this.getPolicyList(id)
            }
        }
        if(this.$route.query.val){
            let {val} = this.$route.query
            this.searchValue(val)
        }
        this.scrollInit()
    },
    methods: {
        // 上拉加载
        scrollInit (){
            const wrapper = document.querySelector('.public')
            this.scroll = new BScroll(wrapper, {
                probeType: 3,
                click: true,
                pullUpLoad: {
                    threshold: -20 // 当上拉距离超过20px时触发 pullingUp 事件
                }
            })
            this.scroll.on('pullingUp', () => {
                this.page ++
                let {id,mode} = this.$route.query
                this.getPolicyList(id, mode,this.page)
                console.log(id, mode,this.page);
                this.scroll.finishPullUp() // 事情做完，需要调用此方法告诉 better-scroll 数据已加载，否则下拉事件只会执行一次
            })
        },
        // 获取扶持政策列表
        getPolicyList(categoryId,contentType='ARTICLE',pageNo=1, pageSize=10) {
            this.$axios({
                url: this.$config.baseUrl + '/lxcia/separatio/get/listByCategoryId',
                method: 'GET',
                params: {
                    categoryId,
                    pageNo,
                    pageSize,
                    contentType
                }
            }).then(res => {
                if(res.data.code == 0){
                    this.policyList = this.policyList.concat(res.data.page.list)
                }
            }).catch(err => {
                console.log(err.response);
            })
        },
        // 根据企业类型获取企业列表
        getCompanyList(companyType,pageNo=1,pageSize=10) {
            this.$axios({
                url: this.$config.baseUrl + '/lxcia/separatio/get/companylist',
                method: 'GET',
                params: {
                    companyType,
                    pageNo,
                    pageSize
                }
            }).then(res => {
                if(res.data.code == 0){
                    this.policyList = res.data.page.list
                }
            }).catch(err => {
                console.log(err.response);
            })
        },
        // 点击视频
        handleItemClick(item){
            this.$router.push({name:'Video',query: {realUrl: item.realUrl}})
        },
        // 搜索
        searchValue(companyName) {
            this.$axios({
                url: this.$config.baseUrl + '/lxcia/separatio/search',
                method: 'GET',
                params: {
                    companyName
                }
            }).then(res => {
                if(res.data.error == 0){
                    console.log(res.data.data);
                    this.policyList = res.data.data
                }
            }).catch(err => {
                console.log(err.response.data.error);
            })
        }
    },      
}
</script>

<style scoped>
.policy{
    background: #F2F3F7;
} 
.container{
    height: calc(100vh - 1rem);
    overflow: auto;
}
.public{
    margin-top: .2rem;
    padding: 0 .3rem;
    background: #fff;
}
.public .doingList{
    overflow: hidden;
}
.public .doingList .lis{
    display: flex;
    margin-bottom: .3rem;
    margin-top: .3rem;
}
.public .doingList .lis .iconBox{
    width: 1.8rem;
    height: 1.2rem;
    margin-right: .2rem;
    display: flex;
    align-items: center;
}
.public .doingList .lis .iconBox img{
    width: 100%;
    max-height: 100%;
}
.public .doingList .lis .rt{
    width: 4.8rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.public .doingList .lis .rt .doingTitle{
    line-height: 1;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}
.public .doingList .lis .rt .times{
    color: #999;
}
</style>